import type { GetStaticProps } from 'next';
import { fetchBlogPosts, fetchCaseStudies } from '../../utils/api/fetchStrapiData';
import { SyntheticDataGenerationPage } from '../../views/syntheticDataGenerationPage/syntheticDataGenerationPage';

export const getStaticProps: GetStaticProps = async () => {
  const [blogPosts, allCaseStudies] = await Promise.all([fetchBlogPosts(), fetchCaseStudies()]);
  const caseStudies = allCaseStudies.slice(0, 3);

  return {
    props: { blogPosts, caseStudies },
  };
};

export default SyntheticDataGenerationPage;
